module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Backspace-491007aec19d1cf37690e0527879216c.svg";